import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { SlackChannel } from '@mode/shared/contract-common';
import { OwnerInfo, ShareDialogSlackForm, SlackAppDetails } from './slack-tab.interface';

@Component({
  selector: 'mode-slack-tab',
  templateUrl: './slack-tab.component.html',
  styleUrls: ['../share-dialog.component.scss', './slack-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SlackTabComponent {
  @Input() slackAppDetails: SlackAppDetails | undefined;
  @Input() schedulingEnabled = false;
  @Input() owner: OwnerInfo | undefined;
  @Output() scheduleDelivery = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() sendSlackMessage = new EventEmitter<ShareDialogSlackForm>();

  public slackForm = this._fb.group({
    channel: this._fb.control('', Validators.required),
    message: this._fb.control(''),
  });

  constructor(private _fb: UntypedFormBuilder) {}

  public get channelControl(): UntypedFormControl {
    return this.slackForm.controls.channel as UntypedFormControl;
  }

  public get messageControl(): UntypedFormControl {
    return this.slackForm.controls.message as UntypedFormControl;
  }

  sendMessage(formValue: ShareDialogSlackForm) {
    const slackChannel = formValue.channel;
    const slackShareForm: ShareDialogSlackForm = {
      channel: slackChannel,
      message: formValue.message,
    };

    this.sendSlackMessage.emit(slackShareForm);
  }

  setSlackChannel(slackChannel: SlackChannel) {
    this.slackForm.controls['channel'].setValue(slackChannel);
  }
}
